<svg class="icon" width="16" height="16" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
  <g fill="none" fill-rule="evenodd">
    <path
      d="M39.805 19.903c0 10.992-8.91 19.902-19.902 19.902C8.91 39.805 0 30.895 0 19.903 0 8.91 8.91 0 19.903 0c10.992 0 19.902 8.91 19.902 19.903"
      fill="#ffffff"
      opacity=".8"
    /><path
      d="M16.14 28.793c-.024 0-.048 0-.073-.002a1.983 1.983 0 0 1-1.436-.692l-5.503-6.402a1.991 1.991 0 0 1 3.02-2.592l4.102 4.77 12.46-12.48a1.99 1.99 0 1 1 2.819 2.811l-13.98 14.002a1.993 1.993 0 0 1-1.408.585"
      fill="#0cb14b"
    />
  </g>
</svg>

<style>
  .icon {
    display: inline-block;
    vertical-align: middle;
    margin-right: 8px;
  }
</style>
